var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplainR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 6C8.1492 6 6 8.14908 6 10.8V20.4C6 23.0508 8.1492 25.2 10.8 25.2L10.8276 25.1916C11.0856 27.8472 13.3776 30 16.1256 30C16.5096 30 18.816 30 19.2 30C23.4624 30 30 23.4624 30 19.2V16.1256C30 13.3772 27.9144 11.0982 25.206 10.8305L25.2 10.8C25.2 8.14908 23.0508 6 20.4 6H10.8ZM10.8 8.4H20.4C21.726 8.4 22.8 9.47448 22.8 10.8C20.5368 10.8 16.9596 10.8 16.1256 10.8C13.1904 10.8 10.8 13.19 10.8 16.1256V22.8C9.474 22.8 8.4 21.726 8.4 20.4V10.8C8.4 9.47448 9.474 8.4 10.8 8.4ZM23.3256 20.4L27.3588 20.3904C26.4612 23.0088 22.9956 26.3784 20.4036 27.3504L20.4 23.3256C20.4 21.7152 21.7152 20.4 23.3256 20.4Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplainR);
export default __webpack_public_path__ + "static/media/complainR.f7cbd993e0b7c56d2e4d9fbe0c2b2b63.svg";
export { ForwardRef as ReactComponent };